module.exports = __webpack_public_path__ + "media/images/front/about/point3_img01-65231e570e0182a8051e47e4d40de198.jpg";